import Link from "next/link";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const PLATFORM_TERMS_URL = "https://www.attend.tech/terms-of-use";
const PLATFORM_PRIVACY_URL = "https://www.attend.tech/privacy-policy";
const RANGERS_PASS_URL = "https://www.newyorkrangers.com/pass";

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "How much does Rangers Pass cost?",
    answer: "Rangers Pass costs $150 per Pass, per month.",
  },
  {
    question: "How many games are included?",
    answer:
      "Each Pass includes access to two eligible Rangers home games per month.",
  },
  {
    question: "Can I select any two games?",
    answer:
      "You may choose from the eligible games available in your Rangers Pass account each month. Game availability is limited and subject to capacity.",
  },
  {
    question: "Where will my seats be located?",
    answer:
      "All Rangers Pass tickets will be located in the 100 Level or 200 Level of The Garden. Exact seats are assigned 4 hours prior to game start.",
  },
  {
    question: "When will I receive my tickets?",
    answer:
      "Your mobile tickets and seat assignments will be added to your account and you will be notified via SMS when they're available 4 hours prior to game start.",
  },
  {
    question: "How do I manage my Pass?",
    answer: (
      <>
        Visit{" "}
        <Link target="_blank" href={RANGERS_PASS_URL}>
          New York Rangers Pass
        </Link>{" "}
        and sign in using your Madison Square Garden Account Manager credentials
        to select games, link Passes and manage your account.
      </>
    ),
  },
  {
    question: "Can I attend with friends?",
    answer:
      "Yes. You can purchase up to four Passes together or link separately purchased Passes before selecting games. Linked Passholders who choose the same games can request to be seated together, subject to availability.",
  },
  {
    question: "When should I link my Pass with a friend?",
    answer:
      "Link your Passes before making your game selections for the month. This allows your group to select the same games and be seated together. Once you have created your group, you do not have to create it again.",
  },
  {
    question: "Does each person need a Rangers Pass?",
    answer:
      "Yes. Each Pass provides one ticket to two games per month. Every person attending will need their own Pass.",
  },
  {
    question: "How can I change my reservation to a different game?",
    answer:
      "Click on the reserved game and select Cancel Reservation on the pop-up. Your reservation will open back up to select another game. You will receive a text message approximately 24 hours before any selected game, which gives you a final chance to change your reservation.",
  },
  {
    question: "Does Rangers Pass automatically renew?",
    answer:
      "Yes. After November opt-in, Rangers Pass renews automatically each month unless canceled between the 15th and 25th of the current month.",
  },
  {
    question: "How do I cancel my Pass?",
    answer:
      "You can cancel through your Rangers Pass account between the 15th and 25th of the current month to prevent the next monthly renewal.",
  },
  {
    question: "Can I transfer my tickets?",
    answer:
      "Rangers Pass tickets may be transferred once seats are assigned 4 hours prior to game start.",
  },
  {
    question: "Are playoff games included?",
    answer:
      "No. Rangers Pass is valid for eligible regular-season home games only.",
  },
];

export const REGISTRATION_TERMS_AND_CONDITION = () => (
  <>
    By creating an account, you agree to receive account-related notification
    and marketing communication from the New York Rangers and you confirm that
    you have read and agree to the platform&apos;s{" "}
    <Link target="_blank" href={PLATFORM_TERMS_URL}>
      Terms &amp; Conditions
    </Link>{" "}
    and{" "}
    <Link target="_blank" href={PLATFORM_PRIVACY_URL}>
      Privacy Policy
    </Link>
    .
  </>
);

export const TERMS_AND_CONDITION = () => (
  <>
    By checking the box you agree to receive notifications regarding your
    purchase and to the{" "}
    <Link target="_blank" href={PLATFORM_TERMS_URL}>
      Terms &amp; Conditions
    </Link>{" "}
    and{" "}
    <Link target="_blank" href={PLATFORM_PRIVACY_URL}>
      Privacy Policy
    </Link>
    .
  </>
);
